import { c, KeyboardShortcut } from 'ui-components';
import { SearchHotkeyHintProps } from './SearchHotkeyHint.types';

/**
 * The ⌘K / Ctrl K chip at the right edge of the empty header box. Touch-only
 * devices never see it, and it steps aside while the box has focus; assistive
 * tech reads the shortcut from the input's aria-keyshortcuts instead.
 */
export const SearchHotkeyHint = ({
  keys,
  hidden = false,
  className = '',
}: SearchHotkeyHintProps) => {
  if (!keys || hidden) {
    return null;
  }

  return (
    <KeyboardShortcut
      keys={keys}
      aria-hidden
      className={c(
        'mr-2 hidden shrink-0 [@media(hover:hover)_and_(pointer:fine)]:inline-flex [@media(hover:hover)_and_(pointer:fine)]:group-focus-within:hidden',
        className
      )}
    />
  );
};
